"use client";

import { c as _c } from "react/compiler-runtime";
import RenderImage from "@/components/atoms/RenderImage";
import { Carousel, CarouselApi, CarouselContent, CarouselItem } from "@/components/ui/carousel";
import { useEffect, useState } from "react";
import { cn } from "@/lib/utils";
import { NoImageAvailable } from "@/components/atoms/NoImageAvailable";
type Props = {
  thumbnail: string[];
  classname?: string;
  hideCounter?: boolean;
  onCurrentChange?: (current: number) => void;
};
export default function RealEstateDetailImageSectionMobileInDetail(t0) {
  const $ = _c(29);
  const {
    thumbnail,
    classname,
    hideCounter,
    onCurrentChange
  } = t0;
  const [api, setApi] = useState();
  const [current, setCurrent] = useState(1);
  const count = thumbnail?.length || null;
  let t1;
  let t2;
  if ($[0] !== api || $[1] !== onCurrentChange) {
    t1 = () => {
      if (!api) {
        return;
      }
      api.on("select", () => {
        const next = api.selectedScrollSnap() + 1;
        setCurrent(next);
        onCurrentChange?.(next);
      });
    };
    t2 = [api, onCurrentChange];
    $[0] = api;
    $[1] = onCurrentChange;
    $[2] = t1;
    $[3] = t2;
  } else {
    t1 = $[2];
    t2 = $[3];
  }
  useEffect(t1, t2);
  let t3;
  if ($[4] !== thumbnail) {
    t3 = thumbnail?.join("|");
    $[4] = thumbnail;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const thumbnailKey = t3;
  let t4;
  if ($[6] !== api || $[7] !== onCurrentChange) {
    t4 = () => {
      setCurrent(1);
      onCurrentChange?.(1);
      api?.scrollTo(0, true);
    };
    $[6] = api;
    $[7] = onCurrentChange;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== api || $[10] !== onCurrentChange || $[11] !== thumbnailKey) {
    t5 = [thumbnailKey, api, onCurrentChange];
    $[9] = api;
    $[10] = onCurrentChange;
    $[11] = thumbnailKey;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  useEffect(t4, t5);
  if (!thumbnail) {
    let t6;
    if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
      t6 = <NoImageAvailable />;
      $[13] = t6;
    } else {
      t6 = $[13];
    }
    return t6;
  }
  let t6;
  if ($[14] !== classname) {
    t6 = cn("w-full relative overflow-hidden", classname);
    $[14] = classname;
    $[15] = t6;
  } else {
    t6 = $[15];
  }
  let t7;
  if ($[16] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = {
      align: "start",
      loop: true
    };
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  let t8;
  if ($[17] !== count || $[18] !== current || $[19] !== hideCounter) {
    t8 = !hideCounter && count && current && <div className="absolute z-10 bottom-12 right-[18px] cursor-pointer bg-gray-900/80 rounded-md flex justify-center items-center px-2.5 py-1"><p className="text-white text-xs">{current}/{count}</p></div>;
    $[17] = count;
    $[18] = current;
    $[19] = hideCounter;
    $[20] = t8;
  } else {
    t8 = $[20];
  }
  let t9;
  if ($[21] !== thumbnail) {
    t9 = thumbnail.length === 0 ? <NoImageAvailable /> : thumbnail.map(_temp);
    $[21] = thumbnail;
    $[22] = t9;
  } else {
    t9 = $[22];
  }
  let t10;
  if ($[23] !== t9) {
    t10 = <CarouselContent className="h-full" data-sentry-element="CarouselContent" data-sentry-source-file="RealEstateDetailImageSectionMobileInDetail.tsx">{t9}</CarouselContent>;
    $[23] = t9;
    $[24] = t10;
  } else {
    t10 = $[24];
  }
  let t11;
  if ($[25] !== t10 || $[26] !== t6 || $[27] !== t8) {
    t11 = <Carousel setApi={setApi} className={t6} opts={t7} data-sentry-element="Carousel" data-sentry-component="RealEstateDetailImageSectionMobileInDetail" data-sentry-source-file="RealEstateDetailImageSectionMobileInDetail.tsx">{t8}{t10}</Carousel>;
    $[25] = t10;
    $[26] = t6;
    $[27] = t8;
    $[28] = t11;
  } else {
    t11 = $[28];
  }
  return t11;
}
function _temp(image, index) {
  return <CarouselItem key={index} className="pl-0"><RenderImage src={image} alt={`Property image ${index + 1}`} className="object-cover cursor-pointer" priority={index === 0} quality={100} sizes="(max-width: 768px) 100vw, 50vw" /></CarouselItem>;
}